module.exports = __webpack_public_path__ + "static/image3-221be2cffb302d5441efbfc1ae0b46ef.png";